import React from "react";
import PropTypes from "prop-types";
import { Table, Toolbar } from "./components";

const Balance = (props) => {
  return (
    <div className="balance-page">
      <div className="balance-header">
        <div>
          <h1 className="balance-title">Balance</h1>
          <p className="balance-subtitle">
            Review all deposits, withdrawals, and account adjustments.
          </p>
        </div>
      </div>

      <div className="balance-card">
        <Toolbar history={props.history} />
        <div className="balance-content">
          <Table />
        </div>
      </div>
    </div>
  );
};

Balance.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};

export default Balance;
